<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/lock-g.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        {{ 'app.identity.stepUp.enrollTitle' | translate }}
      </h2>
      <p class="parent-dialog__subtitle">
        {{ 'app.identity.stepUp.enrollBody' | translate }}
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.identity.stepUp.cancel' | translate"
    (click)="cancel()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<form [formGroup]="form" (ngSubmit)="confirm()">
  <mat-dialog-content class="parent-dialog__body">
    <div class="totp-enroll__qr-wrap">
      <img
        class="totp-enroll__qr"
        [src]="data.qrCodeDataUrl"
        width="196"
        height="196"
        alt=""
      />
    </div>

    <section class="parent-dialog__section">
      <p class="parent-dialog__hint">
        {{ 'app.identity.stepUp.enrollManual' | translate }}
      </p>
      <div class="totp-enroll__secret">
        <code>{{ data.secret }}</code>
        <button
          type="button"
          class="totp-enroll__copy"
          [attr.aria-label]="
            (copied()
              ? 'app.identity.stepUp.copied'
              : 'app.identity.stepUp.copySecret'
            ) | translate
          "
          [attr.title]="
            (copied()
              ? 'app.identity.stepUp.copied'
              : 'app.identity.stepUp.copySecret'
            ) | translate
          "
          (click)="copySecret()"
        >
          <img
            class="copy-icon"
            [src]="
              copied() ? '/public/svgs/copy-check.svg' : '/public/svgs/copy.svg'
            "
            width="16"
            height="16"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
    </section>

    <div class="parent-dialog__form">
      <app-input-field
        formControlName="code"
        [label]="'app.identity.stepUp.totpCode' | translate"
        [type]="'text'"
        [placeholder]="'000000'"
      />
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="parent-dialog__actions parent-dialog-actions"
    align="end"
  >
    <app-parent-button type="button" variant="ghost" (clicked)="cancel()">
      {{ 'app.identity.stepUp.cancel' | translate }}
    </app-parent-button>
    <app-parent-button type="submit" variant="primary">
      {{ 'app.identity.stepUp.enrollConfirm' | translate }}
    </app-parent-button>
  </mat-dialog-actions>
</form>
